

















































import { Component, Vue } from 'vue-property-decorator';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';

@Component({
  components: {
    OrganizationIcon,
  },
})
export default class SubMenuNavigationDrawrer extends Vue {
  private organizationIconColor: string = 'light-blue lighten-3';
  private organizationName: string = 'セオリー開発';
  private organizationIconSize: number = 45;
  private menuIconSize: number = 17;
  private cardWidth: string = '260px';
  private cardElevation: number = 1;

  private menuContentFields: Array<{
    title: string;
    icon: string;
    routeName: string;
  }> = [
    {
      title: '基本設定',
      icon: 'cog-outline',
      routeName: 'organizationBasic',
    },
    {
      title: 'プロジェクト一覧',
      icon: 'format-list-bulleted-square',
      routeName: 'organizationProjects',
    },
    {
      title: '組織メンバー',
      icon: 'account',
      routeName: 'organizationMember',
    },
    {
      title: '利用プランの変更',
      icon: 'book-open-outline',
      routeName: 'changePlan',
    },
    {
      title: '使用容量の確認',
      icon: 'harddisk',
      routeName: 'storageConfig',
    },
  ];

  private selectedMenu(routeName: string) {
    if (routeName === this.$route.name) {
      return 'selected-menu';
    }
  }
}
